import gql from "graphql-tag";

const getStrategy = gql`
  query Query($args: FilterParamsInput) {
    searchStrategies(args: $args) {
      data {
        id
        name
        description
        objectives {
          id
        }
        projects {
          id
            description
            name
            objectives {
              id
            }
            responsibleId
            responsible {
              id
              position
              name
            }
        }
      }
    }
  }
`;

const getFullStrategies = gql`
  query Query($args: FilterParamsInput) {
    searchStrategies(args: $args) {
      data {
        id
        name
        description
        objectives {
          id
          name
        }
        projects {
          id
            description
            name
            objectives {
              id
            }
            responsibleId
            responsible {
              id
              position
              name
            }
          activities {
            historic {
              id
              executed
              planned
              period
            }
            id
            initial_date
            end_date
            name
            responsible {
              id
              position
            }
          }
        }
      }
    }
  }
`;

export { getStrategy, getFullStrategies }